import { z } from 'zod';
import { UserSchema } from '../schemas';

/** Development composition contract; never an alternative production identity. */
export const LocalIdentityProfileSchema = UserSchema.omit({ createdAt: true, updatedAt: true }).extend({
  key: z.string().regex(/^[a-z][a-z0-9-]{0,31}$/),
}).strict();
export const LocalIdentityCredentialSchema = LocalIdentityProfileSchema.extend({ token: z.string().min(32).max(256) });
export const LocalIdentityCredentialsSchema = z.array(LocalIdentityCredentialSchema).min(1).max(20)
  .superRefine((profiles, context) => {
    for (const property of ['key', 'id', 'clerkId', 'token'] as const) {
      if (new Set(profiles.map(profile => profile[property])).size !== profiles.length) {
        context.addIssue({ code: z.ZodIssueCode.custom, message: `Duplicate local identity ${property}` });
      }
    }
  });
export type LocalIdentityProfile = z.infer<typeof LocalIdentityProfileSchema>;
